import Actor from '../physics/Actor';
import THREEParticleEmitter from '../particles/THREEParticleEmitter';

export default class ParticleTile extends THREE.Group {
	constructor(particleType, offset) {
		super();
		this._type = Actor.TILE;
		this._activated = true;
		this.texture = null;
		this._jsonName = particleType;
		this.initTile(particleType, offset);
	}

	initTile(particleType, offset) {
		this._particles = new THREEParticleEmitter(P3.assets.json(particleType), this._activated);
		this._particles.scale.setScalar(1);
		this._particles.position.add(offset);
		this.add(this._particles);
	}

	activate() {
		this.system.dispose();
	}

	update() {
		this._particles.update();
	}

	dispose() {
		this._particles.dispose();
	}

	get activated() {
		return this._activated;
	}

	set activated(v) {
		this._activated = v;
	}

	get jsonName() {
		return this._jsonName;
	}
}
